module.exports = __webpack_public_path__ + "static/img/Lin_Hwa-Ching.png";